import Vue from 'vue'
import ElementUI, { Header } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import axios from 'axios'
import Print from 'vue-print-nb'
import { Message } from 'element-ui'
import * as echarts from 'echarts'
import "../src/assets/js/axios.config"
import XLSX from 'xlsx'
import App from './App.vue'
import router from './router'
import store from './store'

import  darkObj from './assets/js/dark.json'
echarts.registerTheme('dark', darkObj)
// 全局css文件
import './assets/css/reset.css'
import './assets/css/Adaptive.css'
// 引入图标库
import './assets/icon/iconfont.css'
import './plugins/element.js'

// import './css/index.less'
Vue.config.productionTip = false
Vue.prototype.$message = Message;

Vue.use(Print)
Vue.prototype.XLSX = XLSX
Vue.prototype.$echarts = echarts
// import "../src/assets/js/httpsys"
// import "../src/assets/js/apiauth"

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

// 修改主题色
//  import './theme/element/index.css'

 import print from "./utils/print.js"
 Vue.use(print); 
 Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});
axios.defaults.baseURL=`${window.location.protocol}//ai.tcmcds.com`//'http://192.168.0.107:8301/',//'http://ai.tcmcds.com'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
